import { initObi, updateObi } from 'obi-loader';

export function useObi() {
    if (!import.meta.env.VITE_OBI_KEY) {
        return;
    }

    initObi({
        apiKey: import.meta.env.VITE_OBI_KEY,
        position: 'bottom-right',
        isActive: false,
    });

    const userStore = useUserStore();

    watch(
        () => userStore.data,
        (userData) => {
            if (userData) {
                updateObi({
                    isActive: false,
                    user: {
                        id: userData.id,
                        email: userData.email,
                        first_name: userData.first_name,
                        last_name: userData.last_name,
                        company: userData.company.name,
                    },
                });
            } else {
                updateObi({
                    isActive: false,
                    user: null,
                });
            }
        },
        {
            deep: true,
            immediate: true,
        },
    );
}
